import { TNotificationsPopoverItem } from '@components/NotificationsPopover/types/TNotificationsPopoverItem';
import { LastNotificationResponseDto } from 'app/API';

export const mapLastNotificationToPopoverItem = (
  notification: LastNotificationResponseDto,
): TNotificationsPopoverItem => ({
  id: notification.id,
  message: notification.message,
  url: notification.url,
  seen: notification.seen,
  createdAt: notification.createdAt,
  organizationName: notification.Organization?.name || 'AutoScript',
  organizationImage: notification.Organization?.image ?? undefined,
});
